<template>
  <div
    class="notification-item"
    @click.prevent="onClick"
  >
    <div
      class="notification-item__close"
      @click.stop.prevent="onClose"
    >
      <feather-icon
        icon="XIcon"
        svgClasses="h-5 w-5"
      />
    </div>
    <div class="notification-item__title">Новое сообщение</div>
    <div class="notification-item__body">
      <div class="notification-item__avatar">
        <vs-avatar
          size="50px"
          :src="notification.profile_image_url"
          :text="notification.name"
          class="m-0"
        />
      </div>
      <div class="notification-item__message">
        {{ notification.name }}:
        <span v-if="notification.message_type === 'text'">{{ notification.body }}</span>
        <span v-else-if="notification.message_type === 'file'">(файл)</span>
        <span v-else-if="notification.message_type === 'image'">(изображение)</span>
        <span v-else-if="notification.message_type === 'location'">(локация)</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    notification: {
      type: Object,
      required: true
    }
  },

  methods: {
    onClose () {
      this.$emit('close', this.notification)
    },

    onClick () {
      this.$router.push({
        name: 'chats',
        params: {
          client_id: this.notification.client_id
        }
      })
    }
  }
}
</script>
